export const defaultCurrency = 'USD'
export const defaultTimezone = 'America/Los_Angeles'
